// Tile geometry (from Figma node 11232:163091). Tile is fixed-width; the gap is
// the horizontal spacing between tiles on the belt.
export const TILE_WIDTH = 160;
export const TILE_GAP = 8;
export const TILE_STRIDE = TILE_WIDTH + TILE_GAP;

// Continuous scroll speed of the conveyor.
export const SCROLL_SPEED_PX_PER_SEC = 40;

// Max width for the win-amount text — half the tile. useFitText steps the font down
// until the formatted number fits within this, so long amounts never overflow.
export const AMOUNT_MAX_WIDTH = TILE_WIDTH / 2;

// A random subset of tiles "snap" in: once such a tile is halfway into view it
// bursts forward at SCROLL_SPEED_PX_PER_SEC * SNAP_SPEED_MULTIPLIER for the rest
// of its own width, then settles back to the normal speed.
export const SNAP_PROBABILITY = 0.35;
export const SNAP_SPEED_MULTIPLIER = 10;

// Clamp the per-frame delta so a tab-switch, breakpoint, or GC pause can't
// lurch the belt forward by a huge jump on the first frame back.
export const MAX_FRAME_SECONDS = 0.05;

// Extra off-screen tiles kept on either side so recycling at the edges is seamless.
export const VIEWPORT_BUFFER_TILES = 2;
export const WINNERS_ENDPOINT = 'user/winners';
